import { Button, Card, List } from 'antd';
import { MODAL_TYPES, ModalFactory } from 'components/ModalFactory';
import { TenantService } from 'connection/TenantService';
import { Tenant } from 'models/Blip/Index';
import { GridView } from 'models/GridView';
import { AccessKeyRequest } from 'models/request/AccessKeyRequest';
import React, { Component } from 'react';
import { getTemporaryAdminAccessKey } from 'services/CeberusApiService';
import { UserDataSingleton } from 'services/UserDataSingleton';
import { PushNotification } from 'utils/PushNotification';

const ListItem = List.Item
const ListItemMeta = List.Item.Meta

const generateKeyButton = [
  <Button
    key="getAuthorizationKeyButton"
    type="primary"
    shape="round"
    size="small"
    icon="unlock"
    className="ml4">
    Get Temporary Authorization Key
  </Button>
]

export class AdminIdentity extends Component<{ match: any }> {
  tenantSelected: Tenant;
  hasLoadedWithTenant: boolean = false;

  state = {
    editingRecord: {},
    currentModal: '',
    isModalLoading: false,
    isLoading: true,
    gridView: new Array<GridView>(),
    list : [
      {
        identity: 'admin@msging.net',
        generateKey: generateKeyButton
      },
      {
        identity: 'admin@blip.ai',
        generateKey: generateKeyButton
      },
      {
        identity: 'admin@0mn.io',
        generateKey: generateKeyButton
      }
    ]
  }

  componentDidMount() {
    this.loadPage();
  }

  componentDidUpdate() {
    const currentTenant = TenantService.getSelectedTenant();
    if (currentTenant && !this.hasLoadedWithTenant && this.tenantSelected !== currentTenant) {
      this.tenantSelected = currentTenant;
      this.hasLoadedWithTenant = true;
      this.loadPage();
    }
  }

  loadPage = async () : Promise<void> => {
    try {
      this.setState({ isLoading: true });
      this.tenantSelected = TenantService.getSelectedTenant();

      if (!this.tenantSelected) {
        this.setState({ isLoading: false });
        return;
      }
      const gridView = this.mountingItemList();
      this.setState({ gridView });
    } catch (error) {
      PushNotification.error('Error loading admin identity information');
    } finally {
      this.setState({ isLoading: false });
    }
  }

  handleModalVisibility = (type: string, visibility: boolean) : void => {
    switch (type) {
      case MODAL_TYPES.GetAuthorizationKey:
      case MODAL_TYPES.ShowAuthorizationKey:
        this.setState({ currentModal: visibility ? type : '' });
        break
      default:
        PushNotification.warnig('Unrecognized modal type');
    }

    if (!visibility) {
      this.setState({ editingRecord: {} });
    }
  }

  handleOnGetAuthorizationKey = (identity : string) => {
    this.setState({ editingRecord: {
      purpose: '',
      expiration: 900000,
      identity: identity
    } })
    this.handleModalVisibility(MODAL_TYPES.GetAuthorizationKey, true)
  }

  handleGetAuthorizationKey = async () => {
    this.handleModalVisibility(MODAL_TYPES.GetAuthorizationKey, false)
    this.setState({
      isModalLoading: true
    })

    const editingRecord = this.state.editingRecord;
    const purpose = editingRecord['purpose'];
    const expiration = editingRecord['expiration'];
    const identity = editingRecord['identity'];
    const editedPurpose = UserDataSingleton.instance.email + ' - ' + purpose

    try {
      this.tenantSelected = TenantService.getSelectedTenant();
      const data = await getTemporaryAdminAccessKey(new AccessKeyRequest(identity, editedPurpose, expiration, this.tenantSelected.name))
      this.setState({
        editingRecord: {
          key: data.Key
        }
      })
      this.handleModalVisibility(MODAL_TYPES.ShowAuthorizationKey, true)
    } catch (error) {
      PushNotification.httpError(error);
    } finally {
      this.setState({
        isModalLoading: false
      })
    }

  }

  mountingItemList = () : Array<GridView> => {
    const gridView: Array<GridView> = [];

    this.state.list.forEach((admin) => {
      gridView.push({
        title: `Domain: ${admin.identity.split('@')[1]}`,
        description: (
          <div>
            <div>Identity: {admin.identity}</div>
            <div style={{ marginBottom: '9px' }}>
              Authorization Key:
              <Button
                key={`getAuthorizationKeyButton-${admin.identity}`}
                type="primary"
                shape="round"
                size="small"
                icon="unlock"
                onClick={() => this.handleOnGetAuthorizationKey(admin.identity)}>
                Get Temporary Authorization Key
              </Button>
            </div>
          </div>
        )
      });
    });
    return gridView;
  }

  render() {
    return (
      <div>
        <Card title="Admin Identity Information">
          <List
            loading={this.state.isLoading}
            dataSource={this.state.gridView}
            renderItem={item =>
              !item.invisible ? (
                <ListItem>
                  <ListItemMeta
                    title={item.title}
                    description={item.description}>
                  </ListItemMeta>
                </ListItem>
              ) : (
                <></>
              )}>
          </List>
        </Card>

        <ModalFactory
          visible={this.state.currentModal === MODAL_TYPES.GetAuthorizationKey}
          onCancel={() => this.handleModalVisibility(MODAL_TYPES.GetAuthorizationKey, false)}
          loading={this.state.isModalLoading}
          type={this.state.currentModal}
          record={this.state.editingRecord}
          onOk={() => this.handleGetAuthorizationKey()}
          maskClosable={false}
        />

        <ModalFactory
          visible={this.state.currentModal === MODAL_TYPES.ShowAuthorizationKey}
          onCancel={() => this.handleModalVisibility(MODAL_TYPES.ShowAuthorizationKey, false)}
          loading={this.state.isModalLoading}
          type={this.state.currentModal}
          record={this.state.editingRecord}
          onOk={() => this.handleModalVisibility(MODAL_TYPES.ShowAuthorizationKey, false)}
          maskClosable={false}
        />
      </div>
    );
  }
}
